import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// Guarded Supabase client. When the env vars are absent (e.g. before the
// project is wired up, or in a fork without a backend), `supabase` is null
// and the whole app runs in anonymous, localStorage-only mode exactly as
// before. Every consumer must null-check. The anon key is PUBLIC by design
// (Row Level Security is the real boundary), so shipping it in the bundle
// is expected and safe.
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabase: SupabaseClient | null =
  url && anonKey
    ? createClient(url, anonKey, {
        auth: {
          // Persist the session in localStorage and refresh it
          // automatically so users stay signed in across reloads.
          persistSession: true,
          autoRefreshToken: true,
          // Parse the OAuth redirect fragment on return from Google.
          detectSessionInUrl: true,
        },
      })
    : null;

// Convenience flag for UI that should only render when auth is available
// (e.g. the sign-in button). When false, the app is in anonymous mode.
export const isAuthConfigured = supabase !== null;
